var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner"}},[(_vm.model.length)?_c('div',{staticClass:"banner-image",style:({'background-image': 'url(' + _vm.model + ')', 'background-size': 'contain'})}):_c('div',{staticClass:"full-width align-hor center-hor"},[_c('div',{staticClass:"wrapper animate radius-5 banner-image full-width"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba5856c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = null
// module chunks = 